import { useGlobalContentStore } from '~/store/globalContent';

export const useLocalizedCurrency = (price: number, withoutFractions?: boolean): string => {
  const options = {} as Intl.NumberFormatOptions;
  const globalContent = useGlobalContentStore();
  let addedOutput = '';

  const isWholeNumber = price % 1 === 0;

  if (withoutFractions || isWholeNumber) {
    options.maximumFractionDigits = 0;
  } else {
    options.minimumFractionDigits = 2;
    options.maximumFractionDigits = 2;
  }

  // NOK is wrong, so if NOK, we manually format output
  if (globalContent.getCurrency !== 'NOK') {
    options.style = 'currency';
    options.currency = globalContent.getCurrency;
    options.currencyDisplay = 'narrowSymbol';
  } else {
    addedOutput = ' kr';
  }

  const data = new Intl.NumberFormat(
    globalContent.getLocale,
    options).format(price);

  return data + addedOutput;
};
